import React, { useEffect } from 'react';
import { Spinner, color, media } from '@morressier/ts';
import styled from 'styled-components';

import { useAuthContext } from 'context/AuthProvider';
import { useRouter } from 'next/router';

const Page: React.FC = () => {
  const user = useAuthContext();
  const router = useRouter();

  useEffect(() => {
    const redirect = () => {
      if (user?.id) return router.replace('/home');
      else return (location.href = window.location.origin);
    };

    redirect();
  }, [user?.id]);

  return (
    <Wrapper>
      <Spinner />
    </Wrapper>
  );
};

export default Page;

const Wrapper = styled.div`
  background: ${color('white')};
  padding-top: 7rem;
  padding-bottom: 1rem;

  ${media.xxsmall`
    margin-top: 2rem;
  `}
  ${media.medium`
    margin-top: 1rem;
  `}
`;
